import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function registrasiFromStockist(params) {
	return client.post("tunnel/api/pos/registration/registerstockist", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded",
		},
	});
}

function registrasiFromMember(params) {
	return client.post("tunnel/api/pos/registration/registermember", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded",
		},
	});
}

function getHistoryRegister(params) {
	return client.get("tunnel/api/pos/registration/history-register", {
		params: params,
	});
}

export default {
	registrasiFromStockist,
	registrasiFromMember,
	getHistoryRegister
};